const removeWaterMark = {
  ExportVideoWithoutWaterMark: 'Экспортное видео без хитпа водяной знаки',
  ExportWithoutLimits: 'Экспортное видео без ограничений',
  MaximumUpload500MB: 'Максимальный размер загрузки: 500 МБ',
  watermarkRemoveTitle: 'Hitpaw Online Video Watermark Удаление',
  DiscountPrice: '$0.99',
  WeekTotalPrice: '$4.49',

  MonthWeekPrice: '$1.75',
  MonthTotalPrice: '$6.99',

  YearWeekPrice: '$0.87',
  YearTotalPrice: '$41.88',
  Day: 'Day',
  Monthly: 'Ежемесячно',
  Weekly: 'Еженедельно',
  Yearly: 'Ежегодно',
};

export default removeWaterMark;
